export default __webpack_public_path__ + "static/media/2019-interior-1.12b84980.jpeg";